/**
 * @file メッセージマスタデータ取得
 * @namespace ddv2.library
 */

import store from '@/store/DDMasters'

/**
 * @module messages
 */
export default {
  /**
   * メッセージ取得
   * @param {String} messageCd 取得するメッセージ№
   * @param {Array} args 埋め込み文字列リスト
   * @returns 構築済みメッセージ
   * @example
   * messages.get ('COMV0053', ['テスト', 'test'])
   */
  get: function (messageCd, args) {
    const arg = args || []
    const messageList = store.state.msysmessage

    const m = messageList.find((elem) => {
      return elem.messageCd === messageCd
    })

    const result = m.messageKbn === 'V' ? m.gamenKomokuMessage : m.message
    console.log(result)
    if (arg.length === 0) { return result }

    return _embedMessage(result, arg)
  },

  /**
   * メッセージ取得
   * @param {String} messageCd 取得するメッセージコード
   * @param {Array} args 埋め込み文字列リスト
   * @returns msysMessageレコード
   */
  getInfo: function (messageCd, args) {
    const arg = args || []
    const messageList = store.state.msysmessage

    const m = messageList.find((elem) => {
      return elem.messageCd === messageCd
    })

    const result = m.messageKbn === 'V' ? m.gamenKomokuMessage : m.message

    if (arg.length === 0) { return m }

    m.message = _embedMessage(result, arg)
    return m
  }
}
/**
 * メッセージにリストを埋め込む
 * @private
 * @param {String} template 埋め込みテンプレート
 * @param {Array} args 埋め込み文字列リスト
 */
const _embedMessage = function (template, args) {
  let result = template
  for (let i = 0; i < args.length; i++) {
    const mark = `{{${i}}}`
    result = result.split(mark).join(args[i])
  }
  return result
}
